export const config = {
  "_id": {
    "$oid": "64cb98e0527d4956885c1bf2"
  },
  "wf_id": {
    "$oid": "64cb985fa4c06c09eefdd69b"
  },
  "organisation_id": {
    "$oid": "64bfaca761c520f7aeab67e6"
  },
  "parent_wf_id": {
    "$oid": "64cb989b527d4956885aa864"
  },
  "wf_name": "signdesk-test-dynamic",
  "created_by": "",
  "created_at": "",
  "is_active": true,
  "is_deleted": false,
  "dynamic_wf": true,
  "user_initiated": true,
  "last_updated_at": "",
  "last_updated_by": "",
  "configuration_history": [
    {
      "changes": {},
      "module": "",
      "updated_by": "",
      "updated_at": ""
    }
  ],
  "wf_journey": [
    {
      "step": 0,
      "type": "default",
      "module_name": "Dynamic Forms",
      "form_structure": {
        "name": "onboard_form",
        "layout": "regular",
        "nav_orientation": "horizontal",
        "custom_style": "class_name_1 class_name_2",
        "sections": [
          {
            "type": "banner",
            "title": "",
            "orientation": "horizontal",
            "custom_styles": "classname_1 classname_2",
            "occupancy": "30%",
            "show": "localStorage.getItem(\"userToken\") == null",
            "content_type": "html",
            "content": "<div><h3>Create your account</h3><div style='color: '><h5>Onboard yourself in few steps</h5></div></div>"
          },
          {
            "type": "banner",
            "title": "",
            "orientation": "horizontal",
            "custom_styles": "classname_1 classname_2",
            "occupancy": "30%",
            "show": "localStorage.getItem(\"userToken\")?.length",
            "content_type": "html",
            "content": "<div><h3>RM Initiated</h3><h5>Add a new customer in just a few steps</h5><p>Fill up the details and sent them the link for email verification</p></div>"
          },
          {
            "title": "Workflow Verification",
            "name": "workflow_verification",
            "order": 1,
            "show": true,
            "form_groups": [
              {
                "title": "Applicant Consents",
                "name": "applicant_consent",
                "order": 1,
                "show": "false",
                "next_step": 2,
                "form_elements": [
                  {
                    "name": "i_want_to_create_application",
                    "type": "consent",
                    "layout": "regular",
                    "consents": [
                      {
                        "title": "I want to create an Application",
                        "name": "privacy_consent",
                        "label": "Privacy Consent",
                        "consent_id": "6391e2ff5f0c894cfb3d334c"
                      }
                    ]
                  }
                ],
                "form_buttons": [
                  {
                    "label": "Proceed",
                    "action": "next",
                    "disabled": "!formData?.selectedData?.consents?.i_want_to_create_application"
                  }
                ]
              },
              {
                "title": "OTP Verification",
                "name": "otp_verification",
                "order": 2,
                "show": "true",
                "next_step": 3,
                "form_elements": [
                  {
                    "type": "subheader",
                    "name": "otp_verification",
                    "label": "Verification"
                  },
                  {
                    "type": "otp",
                    "id": "email_otp",
                    "name": "email_otp",
                    "label": "Enter the email verification code sent to",
                    "otp_length": 6
                  }
                ],
                "form_buttons": [
                  {
                    "label": "Next",
                    "action": "next",
                    "disabled": "applicantUser?.is_verified == true ? otpReducer?.otpResponse?.email_otp?.status != \"success\" : (otpReducer?.otpResponse?.email_otp?.status != \"success\" || otpReducer?.otpResponse?.whatsapp_otp?.status == \"Failed\")"
                  },
                  {
                    "label": "Submit",
                    "action": "submit",
                    "show": "false"
                  }
                ]
              },
              {
                "title": "Preview Data",
                "name": "preview_data",
                "order": 3,
                "show": "true",
                "form_elements": [
                  {
                    "type": "action_card",
                    "title": "Choose a verified account to proceed further",
                    "show": "true",
                    "input_fields": [
                      {
                        "name": "profile_icon",
                        "expression": "getProfileChars(first_name,1)"
                      },
                      {
                        "name": "first_name"
                      },
                      {
                        "name": "mobile_country_code"
                      },
                      {
                        "name": "mobile_number"
                      },
                      {
                        "name": "email"
                      }
                    ],
                    "flags": {
                      "is_verified": "selectedData.applicant_status",
                      "applicant_type": "selectedData.applicant_type"
                    }
                  }
                ],
                "form_buttons": [
                  {
                    "label": "Proceed",
                    "action": "next",
                    "show": "false"
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "step": 1,
      "module_name": "Dynamic Forms",
      "form_structure": {
        "name": "onboard_form",
        "layout": "wizard",
        "nav_orientation": "horizontal",
        "custom_styles": "classname_1 classname_2",
        "default_wf_fields": {
          "email": "email",
          "full_name": "full_name",
          "mobile_number": "mobile_number"
        },
        "sections": [
          {
            "title": "Basic Information",
            "name": "basic_information",
            "order": 1,
            "show": true,
            "form_groups": [
              {
                "title": "Personal Information",
                "name": "personal_information",
                "order": 1,
                "show": true,
                "form_elements": [
                  {
                    "type": "upload",
                    "id": "pan_card",
                    "placeholder": "",
                    "label": "Upload Pan card",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "show": true,
                    "name": "pan_card",
                    "enum": {
                      "application/pdf": [],
                      "image/png": [],
                      "image/jpeg": []
                    },
                    "maxSize": "10000000",
                    "doc_type": "pan_card",
                    "tooltip": [
                      {
                        "alert_type": "primary",
                        "name": "tin_or_pan_tooltip",
                        "tooltip_text": "PAN is TIN for Indian Residents",
                        "trigger": "!"
                      }
                    ],
                    "validators": {
                      "required": true,
                      "pattern": [],
                      "min_length": "",
                      "max_length": ""
                    },
                    "error_messages": {
                      "min_error": "You have to enter atleast <x> characters",
                      "max_error": "You can't enter more than <x> characters",
                      "pattern_error": "Please upload the appropriate TIN card",
                      "required_error": "This field is mandatory"
                    }
                  },
                  {
                    "type": "group",
                    "title": "",
                    "show": true,
                    "custom_styles": "classname_1",
                    "input_fields": [
                      {
                        "type": "toggle",
                        "id": "is_crn_exist",
                        "label": "Do you have a existing Customers Relationship Number with Kotak ?",
                        "size": "col-lg-12 col-md-12 col-sm-12 ",
                        "name": "is_crn_exist",
                        "is_checked": false,
                        "is_disabled": false
                      },
                      {
                        "type": "text",
                        "id": "existing_crn_number",
                        "label": "Enter CRN ",
                        "size": "col-lg-12 col-md-12 col-sm-12 ",
                        "name": "existing_crn_number",
                        "placeholder": "Eg: 1452-6545-7654-2",
                        "show": "selectedData.is_crn_exist == true",
                        "validators": {
                          "required": false,
                          "pattern": [
                            "^[a-zA-Z0-9][a-zA-Z0-9-/ ]+$"
                          ],
                          "min_length": "",
                          "max_length": "50"
                        },
                        "error_messages": {
                          "min_error": "You have to enter atleast <x> characters",
                          "max_error": "You can't enter more than 50 characters",
                          "pattern_error": "Please enter the appropriate CRN",
                          "required_error": "Required"
                        }
                      },
                      {
                        "type": "checkbox",
                        "id": "branch_name",
                        "label": "Name of the branch",
                        "size": "col-lg-12 col-md-12 col-12 ",
                        "name": "branch_name",
                        "show": "selectedData.is_crn_exist == true",
                        "options": [
                          {
                            "label": "DIFC",
                            "id": "difc",
                            "for": "difc"
                          },
                          {
                            "label": "Kotak Mahindra Bank Limited",
                            "id": "kotak_mahindra_bank_limited",
                            "for": "kotak_mahindra_bank_limited"
                          }
                        ],
                        "validators": {
                          "required": "selectedData.is_crn_exist == true",
                          "pattern": [],
                          "min_length": "",
                          "max_length": ""
                        },
                        "error_messages": {
                          "min_error": "",
                          "max_error": "",
                          "pattern_error": "",
                          "required_error": "This field is mandatory"
                        }
                      }
                    ]
                  },
                  {
                    "type": "dropdown",
                    "id": "client_classification",
                    "label": "Client Classification",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "name": "client_classification",
                    "is_disabled_backup": "(userInfo?.userDetail?.active_step > 1)",
                    "show": "true",
                    "options": [
                      {
                        "label": "Select",
                        "value": ""
                      },
                      {
                        "label": "Assessed Professional client",
                        "id": "option1",
                        "for": "option1"
                      },
                      {
                        "label": "Family member of Assessed Professional Client",
                        "id": "option2",
                        "is_disabled": "isAnyApplicantIndian()",
                        "for": "option2"
                      }
                    ],
                    "validators": {
                      "required": "true",
                      "pattern": [],
                      "min_length": "",
                      "max_length": ""
                    },
                    "error_messages": {
                      "min_error": "",
                      "max_error": "",
                      "pattern_error": "",
                      "required_error": "This field is mandatory"
                    }
                  },
                  {
                    "type": "note",
                    "alert_type": "primary",
                    "trigger": "!",
                    "name": "client_classification_note",
                    "label": "Family member of Assessed Professional Client is not allowed for Indian resident",
                    "size": "col-lg-12 col-md-12 col-sm-12",
                    "show": "(workflowUser.subworkflows.residence_country == \"India\")"
                  },
                  {
                    "type": "dropdown",
                    "id": "applicant_gender",
                    "label": "Gender",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "name": "applicant_gender",
                    "options": [
                      {
                        "label": "Select",
                        "value": ""
                      },
                      {
                        "label": "Male",
                        "id": "option1",
                        "for": "option1"
                      },
                      {
                        "label": "Female",
                        "id": "option2",
                        "for": "option2"
                      },
                      {
                        "label": "Other",
                        "id": "option3",
                        "for": "option3"
                      }
                    ],
                    "validators": {
                      "required": true,
                      "pattern": [],
                      "min_length": "",
                      "max_length": ""
                    },
                    "error_messages": {
                      "min_error": "",
                      "max_error": "",
                      "pattern_error": "",
                      "required_error": "This field is mandatory"
                    }
                  },
                  {
                    "type": "text",
                    "id": "other_gender",
                    "label": "Enter gender",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "name": "other_gender",
                    "show": "selectedData.applicant_gender == \"Other\"",
                    "placeholder": "Eg: Male",
                    "validators": {
                      "required": true,
                      "pattern": "^[a-zA-Z][a-zA-Z ]+$",
                      "min_length": "2",
                      "max_length": "30"
                    },
                    "error_messages": {
                      "min_error": "You have to enter atleast 2 characters",
                      "max_error": "You can't enter more than 30 characters",
                      "pattern_error": "Please enter the appropriate gender",
                      "required_error": "This field is mandatory"
                    }
                  },
                  {
                    "type": "text",
                    "id": "domicile",
                    "label": "Domicile",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "name": "domicile",
                    "placeholder": "Eg: Dubai",
                    "validators": {
                      "required": true,
                      "pattern": "^[a-zA-Z][a-zA-Z ]+$",
                      "min_length": "2",
                      "max_length": "30"
                    },
                    "error_messages": {
                      "min_error": "You have to enter atleast 2 characters",
                      "max_error": "You can't enter more than 30 characters",
                      "pattern_error": "Please enter the appropriate domicile",
                      "required_error": "This field is mandatory"
                    }
                  },
                  {
                    "type": "paymentNote",
                    "alert_type": "primary",
                    "trigger": "!",
                    "payment_id": "payment_module_1",
                    "name": "multipleFileUpload_employment_doc",
                    "dynamic_label": "examinedLabel === 'created' ? 'Editing the payment amount is not possible while the payment is in progress.' : 'The payment amount cannot be edited because the payment has been completed.'",
                    "custom_styles": "p-2 pb-0 mt-2",
                    "show": "selectedData?.payment_ids && selectedData?.payment_ids?.find((paymentId)=>paymentId.name === 'payment_module_1') !== undefined"
                  },
                  {
                    "type": "paymentInput",
                    "id": "payment_amount",
                    "label": "Enter payment amount",
                    "size": "col-lg-12 col-md-12 col-sm-12 ",
                    "name": "payment_amount",
                    "placeholder": "Eg: 100",
                    "payment_id": "payment_module_1",
                    "is_disabled": "'isDisabledPaymentAmount()'",
                    "validators": {
                      "required": true,
                      "pattern": "[0-9]",
                      "min_length": "1",
                      "max_length": "6"
                    },
                    "error_messages": {
                      "min_error": "The payment amount should have at least a single-digit number.",
                      "max_error": "The payment amount cannot exceed six characters (e.g., 100000).",
                      "pattern_error": "Please enter the payment amount in proper format",
                      "required_error": "Payment amount is mandatory"
                    }
                  },
                  {
                    "type": "group",
                    "title": "Married",
                    "show": true,
                    "custom_styles": "classname_2",
                    "input_fields": [
                      {
                        "type": "radio",
                        "id": "marital_status",
                        "label": "Marital Status",
                        "size": "col-lg-6 col-md-6 col-12 ",
                        "name": "marital_status",
                        "options": [
                          {
                            "label": "Married",
                            "id": "option1",
                            "for": "option1"
                          },
                          {
                            "label": "Single",
                            "id": "option2",
                            "for": "option2"
                          },
                          {
                            "label": "Other",
                            "id": "option3",
                            "for": "option3"
                          }
                        ],
                        "validators": {
                          "required": true,
                          "pattern": [],
                          "min_length": "",
                          "max_length": ""
                        },
                        "error_messages": {
                          "min_error": "",
                          "max_error": "",
                          "pattern_error": "",
                          "required_error": "This field is mandatory"
                        }
                      },
                      {
                        "type": "text",
                        "id": "other_marital_status",
                        "label": "Enter marital status",
                        "size": "col-lg-12 col-md-12 col-sm-12 ",
                        "name": "other_marital_status",
                        "show": "selectedData.marital_status == \"Other\"",
                        "placeholder": "Eg: Married",
                        "validators": {
                          "required": true,
                          "pattern": "^[a-zA-Z][a-zA-Z ]+$",
                          "min_length": "2",
                          "max_length": "30"
                        },
                        "error_messages": {
                          "min_error": "You have to enter atleast 2 characters",
                          "max_error": "You can't enter more than 30 characters",
                          "pattern_error": "Please enter the appropriate marital status",
                          "required_error": "This field is mandatory"
                        }
                      }
                    ]
                  },
                  {
                    "type": "group",
                    "title": "",
                    "show": true,
                    "custom_styles": "classname_1",
                    "input_fields": [
                      {
                        "type": "radio",
                        "id": "enter_name",
                        "label": "Please enter father's name or spouse nme",
                        "size": "col-lg-6 col-md-6 col-12 ",
                        "name": "enter_name",
                        "placeholder": "Eg: Victor Kart",
                        "options": [
                          {
                            "label": "Father's name",
                            "id": "option1",
                            "for": "option1"
                          },
                          {
                            "label": "Spouse's name",
                            "id": "option2",
                            "for": "option2"
                          }
                        ],
                        "validators": {
                          "required": true,
                          "pattern": [],
                          "min_length": "",
                          "max_length": ""
                        },
                        "error_messages": {
                          "min_error": "",
                          "max_error": "",
                          "pattern_error": "",
                          "required_error": "This field is mandatory"
                        }
                      },
                      {
                        "type": "text",
                        "id": "spouse_name",
                        "label": "Spouse's Name",
                        "size": "col-lg-12 col-md-12 col-sm-12 ",
                        "name": "spouse_name",
                        "placeholder": "Eg: Victoria",
                        "events": {
                          "onKeyUpCapture": "concatenateFields([selectedData.spouse_name],'','father_and_spouse_name')"
                        },
                        "show": "selectedData.enter_name == \"Spouse's name\"",
                        "validators": {
                          "required": true,
                          "pattern": "^[a-zA-Z][a-zA-Z ]+$",
                          "min_length": "1",
                          "max_length": "45"
                        },
                        "error_messages": {
                          "min_error": "You have to enter atleast 1 characters",
                          "max_error": "You can't enter more than 45 characters",
                          "pattern_error": "Please enter the appropriate spouse name",
                          "required_error": "This field is mandatory"
                        }
                      },
                      {
                        "type": "text",
                        "id": "father_name",
                        "label": "Father's Name",
                        "size": "col-lg-12 col-md-12 col-sm-12 ",
                        "name": "father_name",
                        "events": {
                          "onKeyUpCapture": "concatenateFields([selectedData.father_name],'','father_and_spouse_name')"
                        },
                        "placeholder": "Eg: John",
                        "show": "selectedData.enter_name == \"Father's name\"",
                        "validators": {
                          "required": true,
                          "pattern": "^[a-zA-Z][a-zA-Z ]+$",
                          "min_length": "1",
                          "max_length": "45"
                        },
                        "error_messages": {
                          "min_error": "You have to enter atleast 1 characters",
                          "max_error": "You can't enter more than 45 characters",
                          "pattern_error": "Please enter the appropriate father's name",
                          "required_error": "This field is mandatory"
                        }
                      }
                    ]
                  }
                ],
                "form_buttons": [
                  {
                    "label": "Submit",
                    "action": "paymentSubmit",
                    "triggerPaymentCreation": "true",
                    "amount": "selectedData.payment_amount",
                    "settings": {
                      "configuration_id": "654efc491a2f9c9febfbf43c",
                      "payment_mode": "custom",
                      "payment_type": "custom",
                      "total_amount": "selectedData?.amount",
                      "users_list": [
                        {
                          "name": {
                            "type": "string",
                            "required": true,
                            "value": "user?.full_name"
                          },
                          "email": {
                            "type": "email",
                            "required": true,
                            "value": "user?.email"
                          },
                          "max_amount": {
                            "type": "number",
                            "required": "paymentPayload.sequence == 'sequence' ",
                            "value": "user?.max_amount"
                          },
                          "min_amount": {
                            "type": "number",
                            "required": "paymentPayload.sequence == 'sequence' ",
                            "value": "user?.min_amount"
                          },
                          "user_id": {
                            "type": "ObjectId",
                            "required": "true",
                            "value": "user?.user_id"
                          },
                          "subWfID": {
                            "type": "ObjectId",
                            "required": "true",
                            "value": "user?._id"
                          },
                          "primaryWorkflowId": {
                            "type": "ObjectId",
                            "required": "true",
                            "value": "primaryUser?._id"
                          }
                        }
                      ],
                      "organisation_id": "",
                      "sequence": "parallel",
                      "payment_status": "Payment in progress",
                      "users_list_expected_keys": [
                        "name",
                        "email",
                        "max_amount",
                        "min_amount",
                        "user_id",
                        "primaryWorkflowId",
                        "subWfID"
                      ],
                      "payment_id": "payment_module_1",
                      "payment_in_progress_content": {
                        "title": "Payment in progress",
                        "header": "Payment in progress",
                        "content": "Cannot proceed further until payment is completed either by you or your co-applicant(s)"
                      },
                      "payment_all_users_not_in_same_status": {
                        "title": "Form to be filled by all users",
                        "header": "Form to be filled by all users",
                        "content": "Please wait until all users are yet to fill the form"
                      },
                      "payment_connot_be_done_by_internal_user": {
                        "title": "Payment cannot be done by internal user",
                        "header": "Not authorised to do payment",
                        "content": "Payment cannot be done by internal user"
                      },
                    }
                  }
                ]
              }
            ]
          },
          {
            "title": "Payment",
            "name": "payment_information",
            "order": 2,
            "show": true,
            "module_settings": [],
            "payment_id": "payment_module_1",
            "payment_status": "Payment in progress",
            "form_groups": [
              {
                "title": "Payment Transactions",
                "name": "payment_transactions",
                "order": 1,
                "next_step": 2,
                "show": true,
                "form_elements": [
                  {
                    "type": "label",
                    "name": "payment_transactions_header",
                    "label": "Summary of your past payment transactions"
                  },
                  {
                    "type": "payment_transactions",
                    "title": "Payment Transactions",
                    "show": true,
                    "custom_styles": "classname_1",
                    "name": "payment_module_1",
                    "min_length": 1,
                    "max_length": 3,
                    "recursive_title": "Details of payment transactions",
                    "input_fields": [
                      {
                        "id": "created_at",
                        "label": "Created at",
                        "name": "created_at"
                      },
                      {
                        "id": "paid_by",
                        "label": "Paid by",
                        "name": "paid_by"
                      },
                      {
                        "id": "payment_status",
                        "label": "Payment status",
                        "name": "payment_status"
                      },
                      {
                        "id": "payment_id",
                        "label": "Payment id",
                        "name": "payment_id"
                      },
                      {
                        "id": "payment_gateway",
                        "label": "Payment gateway",
                        "name": "payment_gateway"
                      },
                      {
                        "id": "payment_mode",
                        "label": "Payment mode",
                        "name": "payment_mode"
                      },
                      {
                        "id": "payment_type",
                        "label": "Payment type",
                        "name": "payment_type"
                      },
                      {
                        "id": "amount",
                        "label": "Amount",
                        "name": "amount"
                      },
                      {
                        "id": "transaction_id",
                        "label": "Transaction id",
                        "name": "transaction_id"
                      },
                      {
                        "id": "offline_payment_mode",
                        "label": "Offline payment mode",
                        "name": "offline_payment_mode"
                      },
                      {
                        "id": "type_of_offline_payment",
                        "label": "Type of offline payment",
                        "name": "type_of_offline_payment"
                      },
                      {
                        "id": "payment_document_number",
                        "label": "Payment document number",
                        "name": "payment_document_number"
                      },
                      {
                        "id": "upload_payment_proof",
                        "label": "Upload payment proof",
                        "name": "upload_payment_proof"
                      },
                      {
                        "id": "paymentTransactionId",
                        "label": "PaymentTransactionId",
                        "name": "paymentTransactionId"
                      },
                      {
                        "id": "userId",
                        "label": "UserId",
                        "name": "userId"
                      },
                      {
                        "id": "organisation_id",
                        "label": "Organisation id",
                        "name": "organisation_id"
                      },
                      {
                        "id": "offline_full_payment",
                        "label": "Offline full payment",
                        "name": "offline_full_payment"
                      },
                      {
                        "id": "updated_at",
                        "label": "Updated at",
                        "name": "updated_at"
                      },
                      {
                        "id": "payment_amount",
                        "label": "Payment amount",
                        "name": "payment_amount"
                      },
                      {
                        "id": "offline_partial_type_of_offline_payment",
                        "label": "Offline partial type of offline payment",
                        "name": "offline_partial_type_of_offline_payment"
                      },
                      {
                        "id": "offline_partial_payment_document_number",
                        "label": "Offline partial payment document number",
                        "name": "offline_partial_payment_document_number"
                      }
                    ]
                  }
                ],
                "form_buttons": [
                  {
                    "label": "Next",
                    "action": "next",
                    "disabled": "paymentTransactionsFetching"
                  }
                ]
              }
            ]
          },
          {
            "title": "Submit Application",
            "name": "submit_application",
            "restricted_view": "true",
            "order": 3,
            "show": true,
            "form_groups": [
              {
                "title": "Declarations",
                "name": "declarations",
                "order": 1,
                "show": true,
                "form_elements": [
                  {
                    "type": "consent",
                    "title": "",
                    "show": true,
                    "consents": [
                      {
                        "title": "Declarations",
                        "label": "Terms of Business & Services",
                        "name": "declaration3",
                        "show": "true",
                        "consent_id": "64cc85e7527d4956884bb3a1"
                      }
                    ]
                  }
                ],
                "form_buttons": [
                  {
                    "label": "I agree",
                    "action": "consent"
                  }
                ]
              }
            ]
          }
        ]
      },
      "current_activity": "In draft",
      "next_activity": "Awaiting RM Approval",
      "active": true,
      "previous_step": 1,
      "next_step": 2
    },
    {
      "step": 2,
      "module_name": "payment",
      "current_activity": "Payment in progress",
      "active": true,
      "previous_step": 1,
      "is_conditional": true,
      "next_activity": "Awaiting payment approval",
      "next_step": 3,
      "settings": {
        "configuration_id": "654efc491a2f9c9febfbf43c",
        "payment_mode": "custom",
        "payment_type": "custom",
        "total_amount": "1000",
        "active_step_for_payment": 3,
        "status_after_payment": "Payment Completed",
        "users_list": [
          {
            "name": {
              "type": "string",
              "required": true,
              "value": "user?.full_name"
            },
            "email": {
              "type": "email",
              "required": true,
              "value": "user?.email"
            },
            "max_amount": {
              "type": "number",
              "required": "settings.sequence == 'sequence' ",
              "value": "user?.max_amount"
            },
            "min_amount": {
              "type": "number",
              "required": "settings.sequence == 'sequence' ",
              "value": "user?.min_amount"
            },
            "user_id": {
              "type": "ObjectId",
              "required": "true",
              "value": "user?.user_id"
            },
            "subWfID": {
              "type": "ObjectId",
              "required": "true",
              "value": "user?._id"
            },
            "primaryWorkflowId": {
              "type": "ObjectId",
              "required": "true",
              "value": "primary_workflow?._id"
            }
          }
        ],
        "organisation_id": "",
        "sequence": "parallel",
        "payment_status": "Payment in progress",
        "users_list_expected_keys": [
          "name",
          "email",
          "max_amount",
          "min_amount",
          "user_id",
          "primaryWorkflowId",
          "subWfID"
        ],
        "payment_id": "payment_module_1",
        "payment_in_progress_content": {
          "title": "Payment in progress",
          "header": "Payment in progress",
          "content": "Cannot proceed further until payment is completed either by you or your co-applicant(s)"
        },
        "payment_all_users_not_in_same_status": {
          "title": "Form to be filled by all users",
          "header": "Form to be filled by all users",
          "content": "Please wait until all users are yet to fill the form"
        }
      }
    },
    {
      "step": 3,
      "module_name": "approval",
      "current_activity": "Awaiting payment approval",
      "next_activity": "Awaiting RM approval",
      "previous_step": 2,
      "next_step": 4
    },
    {
      "step": 4,
      "module_name": "approval",
      "current_activity": "Awaiting RM approval",
      "next_activity": "flattendData?.trigger_Vkyc == 'No' ? 'Awaiting Video KYC' : 'Agreement Generation In Progress'",
      "next_step": 5,
      "previous_step": 3
    },
    {
      "step": 5,
      "module_name": "video-kyc",
      "current_activity": "Awaiting Video KYC",
      "next_activity": "Awaiting Video KYC approval",
      "active": true,
      "previous_step": 4,
      "next_step": 6,
      "module": "Non-Assisted",
      "capturing_documents": [
        {
          "field": "passport_doc",
          "type": "front_side_of_passport"
        }
      ],
      "capturing_documents_backup": [
        {
          "field": "pan_card",
          "type": "PAN"
        }
      ]
    },
    {
      "step": 6,
      "module_name": "approval",
      "current_activity": "Awaiting Video KYC approval",
      "next_activity": "Agreement Generation In Progress",
      "active": true,
      "previous_step": 5,
      "next_step": 7
    },
    {
      "step": 7,
      "module_name": "template",
      "current_activity": "Agreement Generation In Progress",
      "next_activity": "Awaiting Esign Completion",
      "templates": [
        {
          "show": true,
          "template_id": "653f7c4f812a03233936da7b",
          "template_doc_name": "Application Form LRS",
          "type": "subworkflow",
          "stamping_required": false
        }
      ],
      "active": true,
      "previous_step": 6,
      "next_step": 8
    },
    {
      "step": 8,
      "module_name": "esign",
      "current_activity": "Awaiting Esign Completion",
      "next_activity": "Application Completed",
      "active": true,
      "previous_step": 7,
      "next_step": 9,
      "esign_settings": [
        {
          "template_id": "653f7c4f812a03233936da7b",
          "conditional_signature": "vbec",
          "signer_type": "single",
          "signature_type": "vbec",
          "access_type": "otp",
          "trigger_esign_request": true,
          "prefer_extracted_data": true,
          "signature_sequence": "parallel",
          "default_signer": false,
          "default_signer_info": [],
          "authentication_mode": "email",
          "validation_input_fields": {
            "name_as_per_passport": "name_as_per_passport",
            "passport_number": "passport_number"
          },
          "document_verification_type": "passport",
          "document_field": "passport_doc",
          "co_signer": true,
          "custom_signing_method": true,
          "custom_signing_settings": {
            "vbec_passport": {
              "name_as_per_passport": "name_as_per_passport",
              "passport_number": "passport_number"
            },
            "vbec_pan": {
              "name_as_per_pan": "name_as_per_pan_card",
              "pan_number": "pan_number"
            },
            "aadhaar": {
              "name_as_per_aadhaar": "name_as_per_aadhaar",
              "last_four_digits_of_aadhaar": "aadhaar_number"
            },
            "HSM": {
              "hsm_user_id": "63eca32b0da9a2e48bbc33ce"
            },
            "CloudSign": {
              "cloudsign_user_id": "63eca32b0da9a2e48bbc33ce"
            }
          },
          "key_terms": [
            {
              "key_term": "Do you agree to all the terms and conditions as laid out in the Application of SignDeskForm."
            }
          ],
          "show": true
        }
      ]
    },
    {
      "active": true,
      "module_name": "approval",
      "current_activity": "Application Completed",
      "next_activity": "Application Completed 2",
      "next_step": 10,
      "previous_step": 8,
      "step": 9
    },
    {
      "active": true,
      "module_name": "approval",
      "current_activity": "Application Completed2",
      "next_activity": "Application Completed 3",
      "next_step": 11,
      "previous_step": 9,
      "step": 10
    }
  ]
}